
export default {
	SEASON: 'eventseason',
	NAME: 'eventname',
	STARTDATE: 'startdate',
	ENDDATE: 'enddate',
	CENTER_CERTNUMBER : 'centercertnumber',
	CENTER_NAME       : 'centername',
	EVENT_COUNTRY     : 'eventcountry',
	EVENT_ADDRESS     : 'eventaddress',
	EVENT_CITY        : 'eventcity',
	EVENT_STATE       : 'eventstate',
	EVENT_ZIPCODE     : 'eventzipcode',
	MEMBERID_PREFIX   : 'memberidprefix',
	MEMBERID_SUFFIX   : 'memberidsuffix',
	DIRECTOR_NAME     : 'directorname',
	DIRECTOR_SSOEMAIL : 'directorssoemail',
	DIRECTOR_PHONE    : 'directorphone',
	DIRECTOR_COUNTRY  : 'directorcountry',
	DIRECTOR_ADDRESS1 : 'directoraddress1',
	DIRECTOR_ADDRESS2 : 'directoraddress2',
	DIRECTOR_CITY     : 'directorcity',
	DIRECTOR_STATE    : 'directorstate',
	DIRECTOR_ZIPCODE  : 'directorzipcode',
	EVENT_EMAIL       : 'eventemail',
	ISVALID_EVENT_INFO: 'isValidEventInfo',
	IS_EVENT_INFO_VERIFIED: 'isEventInfoVerified',
	EVENT_VERIFICATION_EMAIL_SENT: 'eventVerificationEmailSent'
}


// WEBPACK FOOTER //
// ./src/containers/event/components/eventInfo/fields.js